import { render, staticRenderFns } from "./BudgetTrendChart.vue?vue&type=template&id=74a64f12&scoped=true"
import script from "./BudgetTrendChart.vue?vue&type=script&lang=js"
export * from "./BudgetTrendChart.vue?vue&type=script&lang=js"
import style0 from "./BudgetTrendChart.vue?vue&type=style&index=0&id=74a64f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a64f12",
  null
  
)

export default component.exports